<ng-container [formGroup]="form">
  <app-table-header-column name="check" (click)="selectAllGoods()" styleType="old">
    <span content>
      <mat-checkbox [checked]="allChecked" (click)="$event.preventDefault()"></mat-checkbox>
    </span>
  </app-table-header-column>

  <app-table-header-column name="date" styleType="old" size="small">
    <span content>
      Data de entrada
      <app-filter-button
        [column]="'crateEntryEventTimestamp'"
        [menu]="crateEntryEventTimestampFilterMenu"
        [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn"
        #crateEntryEventTimestampFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #crateEntryEventTimestampFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por data de entrada</h4>
      <button (click)="sort('crateEntryEventTimestamp', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['crateEntryEventTimestamp'] && sortDirection == 'DESC'"></i>
      </button>
      <button (click)="sort('crateEntryEventTimestamp', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['crateEntryEventTimestamp'] && sortDirection == 'ASC'"></i>
      </button>
      <mat-form-field appearance="outline">
        <mat-label>Data inicial</mat-label>
        <input matInput [matDatepicker]="startDatePicker" formControlName="crateEntryEventTimestampStartDate" required [max]="maxDate" disabled
          (dateChange)="onStartDateChange()">
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker disabled="false"></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Data final</mat-label>
        <input matInput [matDatepicker]="endDatePicker" formControlName="crateEntryEventTimestampEndDate"
          required [max]="maxDate" disabled (dateChange)="onEndDateChange()" [min]="minDate"
        >
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker disabled="false"></mat-datepicker>
      </mat-form-field>
        <section class="actions">
          <button mat-stroked-button class="gray-1" (click)="clearFilters(crateEntryEventTimestampFilterBtn.menuTrigger, 'crateEntryEventTimestamp')">
            Limpar
          </button>
          <button mat-raised-button class="primary-1" (click)="applyFilters(crateEntryEventTimestampFilterBtn.menuTrigger)"
            [disabled]="isCrateEntryEventTimestampSaveBtnDisabled">
            Salvar
          </button>
        </section>
    </div>
  </mat-menu>
  
  <app-table-header-column name="position" styleType="old" size="small">
    <span content>
      Posição
      <app-filter-button
        [column]="'groundPositionAlias'"
        [menu]="groundPositionAliasFilterMenu"
        [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn"
        #groundPositionAliasFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #groundPositionAliasFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por posição</h4>
      <button (click)="sort('groundPositionAlias', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['groundPositionAlias'] && sortDirection == 'DESC'"></i>
      </button>
      <button (click)="sort('groundPositionAlias', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['groundPositionAlias'] && sortDirection == 'ASC'"></i>
      </button>
      <mat-form-field appearance="outline">
        <input matInput placeholder="Posição" formControlName="groundPositionAlias" autocomplete="off">
        <mat-error>Posição inválida</mat-error>
      </mat-form-field>
      <section class="actions">
        <button mat-stroked-button class="gray-1" (click)="clearFilters(groundPositionAliasFilterBtn.menuTrigger, 'groundPositionAlias')">
          Limpar
        </button>
        <button mat-raised-button class="primary-1" (click)="applyFilters(groundPositionAliasFilterBtn.menuTrigger)">Salvar</button>
      </section>
    </div>
  </mat-menu>

  <app-table-header-column name="document" size="intermediate" styleType="old">
    <span content>
      Documento
      <app-filter-button
        [column]="'inOrderNumber'"
        [menu]="inOrderNumberFilterMenu"
        [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn"
        #inOrderNumberFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #inOrderNumberFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por documento</h4>
      <button (click)="sort('inOrderNumber', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['inOrderNumber'] && sortDirection == 'DESC'"></i>
      </button>
      <button (click)="sort('inOrderNumber', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['inOrderNumber'] && sortDirection == 'ASC'"></i>
      </button>
      <mat-form-field appearance="outline">
        <input matInput placeholder="Documento" formControlName="inOrderNumber" autocomplete="off">
      </mat-form-field>
      <section class="actions">
        <button mat-stroked-button class="gray-1" (click)="clearFilters(inOrderNumberFilterBtn.menuTrigger, 'inOrderNumber')">
          Limpar
        </button>
        <button mat-raised-button class="primary-1" (click)="applyFilters(inOrderNumberFilterBtn.menuTrigger)">Salvar</button>
      </section>
    </div>
  </mat-menu>

  <app-table-header-column name="user" styleType="old">
    <span content>Usuário</span>
  </app-table-header-column>

  <app-table-header-column name="product" styleType="old">
    <span content>
      Código do Item
      <app-filter-button
        [column]="'sku'"
        [menu]="productSkuFilterMenu"
        [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn"
        #skuFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #productSkuFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por código do item</h4>
      <button (click)="sort('sku', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['sku'] && sortDirection == 'DESC'"></i>
      </button>
      <button (click)="sort('sku', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['sku'] && sortDirection == 'ASC'"></i>
      </button>
        <mat-form-field appearance="outline">
          <input matInput placeholder="Código do Item" formControlName="sku" autocomplete="off">
        </mat-form-field>
        <section class="actions">
          <button mat-stroked-button class="gray-1" (click)="clearFilters(skuFilterBtn.menuTrigger, 'sku')">
            Limpar
          </button>
          <button mat-raised-button class="primary-1" (click)="applyFilters(skuFilterBtn.menuTrigger)">Salvar</button>
        </section>
    </div>
  </mat-menu>

  <app-table-header-column name="description" styleType="old">
    <span content>
      Descrição
      <app-filter-button
        [column]="'productName'"
        [menu]="descriptionFilterMenu"
        [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn"
        #descriptionFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #descriptionFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por descrição</h4>
      <button (click)="sort('productName', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['productName'] && sortDirection == 'DESC'"></i>
      </button>
      <button (click)="sort('productName', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['productName'] && sortDirection == 'ASC'"></i>
      </button>
        <mat-form-field appearance="outline">
          <input matInput placeholder="Descrição" formControlName="productName" autocomplete="off">
        </mat-form-field>
        <section class="actions">
          <button mat-stroked-button class="gray-1" (click)="clearFilters(descriptionFilterBtn.menuTrigger, 'productName')">
            Limpar
          </button>
          <button mat-raised-button class="primary-1" (click)="applyFilters(descriptionFilterBtn.menuTrigger)">Salvar</button>
        </section>
    </div>
  </mat-menu>

  <app-table-header-column name="family" styleType="old">
    <span content>
      Família
      <app-filter-button
        [column]="'productDescription'"
        [menu]="familyFilterMenu"
        [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn"
        #familyFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #familyFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por família</h4>
      <button (click)="sort('productDescription', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['productDescription'] && sortDirection == 'DESC'"></i>
      </button>
      <button (click)="sort('productDescription', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['productDescription'] && sortDirection == 'ASC'"></i>
      </button>
        <mat-form-field appearance="outline">
          <input matInput placeholder="Família" formControlName="productDescription" autocomplete="off">
        </mat-form-field>
        <section class="actions">
          <button mat-stroked-button class="gray-1" (click)="clearFilters(familyFilterBtn.menuTrigger, 'productDescription')">
            Limpar
          </button>
          <button mat-raised-button class="primary-1" (click)="applyFilters(familyFilterBtn.menuTrigger)">Salvar</button>
        </section>
    </div>
  </mat-menu>

  <app-table-header-column name="quantity" styleType="old">
    <span content>
      Qtd
      <app-filter-button
        [column]="'totalQuantity'"
        [menu]="totalQuantityFilterMenu"
        [appliedFilters]="appliedFilters"
        [sortColumn]="sortColumn"
        #totalQuantityFilterBtn>
      </app-filter-button>
    </span>
  </app-table-header-column>

  <mat-menu #totalQuantityFilterMenu="matMenu">
    <div class="menu-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h4>Filtrar por quantidade</h4>
      <button (click)="sort('totalQuantity', 'DESC')" mat-menu-item>
        Ordem decrescente
        <i class="uil uil-check" *ngIf="showCheckIcon['totalQuantity'] && sortDirection == 'DESC'"></i>
      </button>
      <button (click)="sort('totalQuantity', 'ASC')" mat-menu-item>
        Ordem crescente
        <i class="uil uil-check" *ngIf="showCheckIcon['totalQuantity'] && sortDirection == 'ASC'"></i>
      </button>
      <mat-form-field appearance="outline">
        <input matInput placeholder="Quantidade" type="number" formControlName="totalQuantity" min="1" autocomplete="off">
      </mat-form-field>
      <section class="actions">
        <button mat-stroked-button class="gray-1"
          (click)="clearFilters(totalQuantityFilterBtn.menuTrigger, 'totalQuantity')">
          Limpar
        </button>
        <button mat-raised-button class="primary-1" (click)="applyFilters(totalQuantityFilterBtn.menuTrigger)">Salvar</button>
      </section>
    </div>
  </mat-menu>

  <app-table-header-column name="messages" styleType="old">
    <span content>Comentários</span>
  </app-table-header-column>

  <app-table-header-column name="rfid" styleType="old">
  </app-table-header-column>
</ng-container>